import { isConfig2Project } from "@/config";
import { Provider } from "@/types/games";

export type ProviderCategory = "slot" | "live";

/** How the back office shows each provider: a badge and what it offers. */
export const PROVIDER_INFO: Record<
	Provider,
	{ initials: string; category: ProviderCategory; beta?: boolean }
> = {
	[Provider.PGHARD]: { initials: "PG", category: "slot" },
	[Provider.PPHARD]: { initials: "PP", category: "slot" },
	[Provider.JILIHARD]: { initials: "JL", category: "slot" },
	[Provider.JOKERHARD]: { initials: "JK", category: "slot" },
	[Provider.SAHARD]: { initials: "SA", category: "live" },
	[Provider.EVPHARD]: { initials: "EV", category: "slot" },
	[Provider.FCGHARD]: { initials: "FC", category: "slot" },
	[Provider.NLCHARD]: { initials: "NL", category: "slot" },
	[Provider.NEXTSPINHARD]: { initials: "NS", category: "slot" },
	[Provider.SEXYHARD]: { initials: "SX", category: "live" },
};

// The tripleclick branding shows the plain provider names.
const CONFIG2_LABELS: Partial<Record<Provider, string>> = {
	[Provider.PGHARD]: "PG",
	[Provider.JILIHARD]: "JILI",
	[Provider.JOKERHARD]: "JOKER",
};

/** "PGHARD", "NEXTSPINHARD" … ("PG", "JILI", "JOKER" on config2 brandings) */
export const providerLabel = (provider: Provider | string) =>
	(isConfig2Project && CONFIG2_LABELS[provider as Provider]) ||
	provider.toUpperCase();

// Providers whose games moved under another provider. The provider rows stay in the database for history,
// so the API can still list them; the back office hides them everywhere.
export const RETIRED_PROVIDERS: ReadonlySet<string> = new Set([
	// gen-2 JOKER, until its games moved under jokerhard on 2026-10-16
	"jokerhard-beta",
	// gen-2 JILI, until its games moved under jilihard on 2026-10-22
	"jilihard-beta",
]);

export const isRetiredProvider = (provider?: string | null) =>
	RETIRED_PROVIDERS.has((provider ?? "").toLowerCase());
